import * as React from "react";
import { FormattedMessage } from "react-intl";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import Link from "./link";

const renderOptions = {
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const { image, mobileImage, imageAlt, text, link } =
        node.data.target || {};

      if (image) {
        return (
          <ImageWithText
            image={image}
            mobileImage={mobileImage}
            imageAlt={imageAlt}
            text={text}
            link={link}
          />
        );
      }

      return null;
    },

    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },
};

const Benefits = ({ product }) => {
  const {
    includedAtTheCamp,
    includedOnGravel,
    includedBeyondGravel,
    notIncluded,
    benefits_options,
  } = product;

  if (
    includedAtTheCamp &&
    includedOnGravel &&
    includedBeyondGravel &&
    notIncluded
  ) {
    return (
      <section className="benefits" aria-labelledby="benefits-heading">
        <div className="container">
          <div className="benefits-content">
            <h2 id="benefits-heading" className="visually-hidden">
              <FormattedMessage id="benefits" />
            </h2>
            <div className="benefits-grid">
              <div>
                <h3 className="heading">
                  <FormattedMessage id="benefitsIncluded" />
                </h3>
                <ul className="benefits-included">
                  {includedAtTheCamp.map((includedItem) => (
                    <li key={includedItem}>{includedItem}</li>
                  ))}
                  {includedOnGravel.map((includedItem) => (
                    <li key={includedItem}>{includedItem}</li>
                  ))}
                  {includedBeyondGravel.map((includedItem) => (
                    <li key={includedItem}>{includedItem}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="heading">
                  <FormattedMessage id="benefitsNotIncluded" />
                </h3>
                <ul className="benefits-not-included">
                  {notIncluded.map((notIncludedItem) => (
                    <li key={notIncludedItem}>{notIncludedItem}</li>
                  ))}
                </ul>
                {benefits_options && (
                  <>
                    <h3 className="heading">Options</h3>
                    <ul className="benefits-options">
                      {renderRichText(benefits_options, renderOptions)}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return null;
};

export default Benefits;
